// extracted by mini-css-extract-plugin
export default {"article":"Article_article__hf-+O","title":"Article_title__Vl4J2","body":"Article_body__+A7yH","fadeIn":"Article_fadeIn__Yq4sX","hoverLineLink":"Article_hoverLineLink__vMZeq"};